import React from "react";
import { useLocale } from "../../i18n/LocaleContext";

const LOGOS = [
  "Coca-Cola",
  "PepsiCo",
  "Danone",
  "Unilever",
  "JDE Peet's",
  "Nestlé",
  "Procter & Gamble",
  "Mondelēz",
  "AB InBev",
  "Heineken",
  "Kraft Heinz",
  "Diageo",
];

export default function TrustBar() {
  const { t } = useLocale();
  return (
    <section
      data-testid="trust-bar"
      className="bg-white border-y border-slate-200/80 py-8"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row items-start md:items-center gap-6 md:gap-10">
          <div className="shrink-0">
            <div className="text-xs uppercase tracking-[0.18em] text-slate-500 font-semibold">
              {t("landing.trust.eyebrow")}
            </div>
            <div className="text-sm text-slate-700 mt-1">
              {t("landing.trust.sub")}
            </div>
          </div>
          <div className="flex-1 overflow-hidden relative">
            <div className="flex gap-10 whitespace-nowrap animate-marquee">
              {[...LOGOS, ...LOGOS].map((name, i) => (
                <span
                  key={`${name}-${i}`}
                  className="font-display text-slate-400/80 hover:text-slate-700 transition-colors text-lg md:text-xl font-semibold tracking-tight"
                  data-testid={`trust-logo-${i}`}
                >
                  {name}
                </span>
              ))}
            </div>
            <div className="pointer-events-none absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-white to-transparent" />
            <div className="pointer-events-none absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-white to-transparent" />
          </div>
        </div>
      </div>
    </section>
  );
}
